import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { getFocalPoint } from 'src/utils/mediaHelpers';

export const getArticleCardProps = (node: IArticleCard) => {
  const { title, drupal_id } = node;
  const summary = node.body.summary ?? undefined;
  const url = node.path?.alias;

  const image = node.relationships.field_image?.relationships.field_media_image?.gatsbyImage;
  const imageField = node.relationships.field_image;

  return {
    title,
    type: 'article_card',
    name: '',
    drupal_id,
    url,
    summary,
    cardType: 'related_article_component',
    imageComponent: image ? (
      <GatsbyImage
        alt=""
        aria-hidden="true"
        image={image}
        imgStyle={{
          objectFit: 'cover',
        }}
        className="lg:pds-h-full"
        objectPosition={getFocalPoint(imageField)}
      />
    ) : (
      <StaticImage
        aspectRatio={1.5}
        src="../assets/media/images/cat-dog-article-placeholder-2.jpg"
        alt=""
        aria-hidden="true"
      />
    ),
  } as const;
};
